import Hero_section from "../Blc_Home/Hero_Section/Hero_section";
import Facilities from "./Facilities/Facilities";
import Hero_Section_Facility from "./Hero_Section_Facility/Hero_Section_Facility";
import Blc_partner from "../Blc_Home/Blc_partner/Blc_partner";
import { useBlcFacilityPageData } from "../Blc_Business/BlcFacilityPage/BlcFacilityPage";
import Spinner from "react-bootstrap/Spinner";
import { Helmet } from "react-helmet";


const Blc_facilities = (props) => {

    return (
        <div>
            <Helmet>
                <title>Learning Facilities and Our Pricing | Brac Learning Centre</title>
                <meta name="description" content="Brac Learning centre offers best learning facilities with safe
environment. View reservation pricing for resort and training solution facilities." />
                <meta name="keywords" content="corporate commercial facilities, corporate conference facilities,
corporate picnic facilities, corporate picnic venues, corporate picnic locations near
me, best business venues, corporate event center, corporate conference center in
Bangladesh, commercial space for rent" />
            </Helmet>
            <Hero_Section_Facility heroVal={props.valFacility} />
            <Facilities valBody={props.valFacility} />
            {/* <Blc_partner val={props.valPartner}></Blc_partner> */}
        </div>
    )
}


export default Blc_facilities;
